


























































import Vue from 'vue';
// import GRoundedArrowButton from '@/components/Molecules/GRoundedArrowButton.vue';

export default Vue.extend({
  name: 'GErrorIe',
  // components: {
  //   GRoundedArrowButton,
  // },
});
